/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Costbreakdown_Title1Inputs */

const zh_analytics_costbreakdown_title1 = /** @type {(inputs: Analytics_Costbreakdown_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型用量明细`)
};

const en_analytics_costbreakdown_title1 = /** @type {(inputs: Analytics_Costbreakdown_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model Usage Breakdown`)
};

const es_analytics_costbreakdown_title1 = /** @type {(inputs: Analytics_Costbreakdown_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose de uso por modelo`)
};

/**
* | output |
* | --- |
* | "Model Usage Breakdown" |
*
* @param {Analytics_Costbreakdown_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_costbreakdown_title1 = /** @type {((inputs?: Analytics_Costbreakdown_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Costbreakdown_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_costbreakdown_title1(inputs)
	if (locale === "en") return en_analytics_costbreakdown_title1(inputs)
	return es_analytics_costbreakdown_title1(inputs)
});
export { analytics_costbreakdown_title1 as "analytics_costBreakdown_title" }